import type { DraftInput } from '../../../../shared/drafts';

function createQuestion(level: number): DraftInput['questions'][number] {
  return {
    prompt: `${level}. gol sorusu`, wagonStyle: 'wide', levels: [level], timeLimitSeconds: null,
    choices: [
      { text: 'Doğru cevap', isCorrect: true },
      { text: 'Yanlış cevap 1', isCorrect: false },
      { text: 'Yanlış cevap 2', isCorrect: false },
    ],
  };
}

export function createGoalArenaDraft(): DraftInput {
  return {
    title: 'Yeni Gol Arenası', templateKey: 'goal-arena', levelMode: 'manual',
    maxLevels: 4, trackTime: true, timingMode: 'none',
    questions: Array.from({ length: 4 }, (_, index) => createQuestion(index + 1)),
  };
}

export function resizeGoalArenaDraft(draft: DraftInput, maxLevels: number): DraftInput {
  const safeLevels = Math.max(4, Math.min(20, Math.trunc(maxLevels)));
  return {
    ...draft, templateKey: 'goal-arena', levelMode: 'manual', maxLevels: safeLevels,
    trackTime: true, bridgeMode: undefined, timingMode: 'none',
    questions: Array.from({ length: safeLevels }, (_, index) => {
      const level = index + 1;
      return { ...(draft.questions.find((question) => question.levels[0] === level) ?? createQuestion(level)), levels: [level], timeLimitSeconds: null };
    }),
  };
}
